module.exports = ".ssf-consent {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 0.8rem;\n  color: #071083;\n  margin-right: 0.5rem; }\n\n.ssf-consent__title {\n  font-weight: bold;\n  margin-right: 0.5rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/consent/components/consent/consent.component.scss
// module id = 608
// module chunks = 3